import { Button, Card, Col, Row } from '@pankod/refine-antd';
import { OrgCreateModal } from 'components/modal';
import { OrgSelectCard } from 'components/organization';
import { useState } from 'react';
import useOrganizationStore from 'store/useOrganizationStore';

const OrgSetupShow: React.FC = () => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const { organizations } = useOrganizationStore();

  return (
    <>
      <OrgCreateModal
        isModalOpen={isCreateModalOpen}
        closeModal={() => setIsCreateModalOpen(false)}
      />

      <Row gutter={[12, 12]}>
        {/* Org Selection Cards*/}
        {organizations.map((org) => (
          <Col key={org.id}>
            <OrgSelectCard id={org.id} name={org.displayName} />
          </Col>
        ))}

        {/* Org Creation Card */}
        <Col>
          <Card style={{ width: '250px' }}>
            <div
              style={{
                border: '1px dashed #dee0e2',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '1.5rem',
                borderRadius: '3px',
              }}
            >
              <Button onClick={() => setIsCreateModalOpen(true)}>Create New</Button>
            </div>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default OrgSetupShow;
